import { render } from "./GroupManagerModal.vue?vue&type=template&id=442a814c&scoped=true"
import script from "./GroupManagerModal.vue?vue&type=script&lang=js"
export * from "./GroupManagerModal.vue?vue&type=script&lang=js"

import "./GroupManagerModal.vue?vue&type=style&index=0&id=442a814c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-442a814c"]])

export default __exports__